import React, { useState, useEffect, Fragment, useMemo } from 'react'
import { Highlighter } from 'react-bootstrap-typeahead'
import TypeaheadInput from 'components/TypeaheadInput'
import './style.scss'

const SelectServiceDefinition = props => {
  const [state, setState] = useState(() => {
    return {
      ...props
    }
  })
  const [instanceKey, setInstanceKey] = useState(0)

  const sortedOptions = useMemo(() => {
    return state.options.slice().sort((a, b) => a.label.localeCompare(b.label))
  }, [state.options])

  // `typeahead-select:restore` is used when the user cancels a confirmation. Reset the selection to
  // the previous value and remount the (uncontrolled) TypeaheadInput so the displayed label reverts.
  useEffect(() => {
    const handleRestore = event => {
      const restoredValue = parseInt(event.detail?.value)
      const restored = state.options.find(item => item.value === restoredValue)

      setState(prev => ({ ...prev, selected: restored ? restored.value : null }))
      setInstanceKey(key => key + 1)
    }

    window.addEventListener('typeahead-select:restore', handleRestore)
    return () => window.removeEventListener('typeahead-select:restore', handleRestore)
  }, [state.options])

  const onChange = value => {
    const selected = state.options.find(item => item.value === value)

    setState(() => ({ ...props, selected: selected }))
    dispatchData(selected)
  }

  const dispatchData = value => {
    var customEvent = new CustomEvent('typeahead-select:change', {
      detail: value
    })
    window.dispatchEvent(customEvent)
  }

  const renderMenuItemChildren = (option, props) => {
    return (
      <Fragment>
        <div className='d-flex'>
          <span className='me-3 my-auto code'>
            <Highlighter search={props.text}>{option.hcpcs}</Highlighter>
          </span>
          <span className='me-3 my-auto'>
            <Highlighter search={props.text}>{option.label}</Highlighter>
          </span>
          <div className='my-auto ms-auto'>
            <span className='text-grey'>{option.amount}</span>
          </div>
        </div>
      </Fragment>
    )
  }

  return (
    <>
      <div
        className={`input required  select-service-definition ${state.errors ? 'error' : null} `}
        id='service_definition_id_input'
      >
        <label className={`label mb-2`}>
          Which service? <abbr title='required'>*</abbr>
        </label>
        <br />
        <div className='org-typeahead'>
          <TypeaheadInput
            {...state}
            key={instanceKey}
            filterBy={['hcpcs', 'full_name']}
            options = {sortedOptions}
            onChange={onChange}
            renderMenuItemChildren={renderMenuItemChildren}
          />
        </div>
      </div>
    </>
  )
}

export default SelectServiceDefinition
